/**
 * "3–10 vjeç" / "3+ vjeç" / "Deri në 8 vjeç" for a product's recommended
 * age, or null when the product has no age data. Shared by the product
 * card and the product page so both always read the same.
 */
export function ageLabel(t, product) {
  const min = product?.ageMin;
  const max = product?.ageMax;
  if (min == null && max == null) return null;
  if (min != null && max != null) return t('pdp.ageRange', { min, max, defaultValue: `${min}–${max} yrs` });
  if (min != null) return t('pdp.ageMinPlus', { min, defaultValue: `${min}+ yrs` });
  return t('pdp.ageMaxOnly', { max, defaultValue: `Up to ${max} yrs` });
}
